import React from 'react';

const FooterSection = () => (
  <footer className="bg-img-cover bg-overlay-black-5 pb-0 section">
    <div className="container-fluid">
      <div className="row">
        <div className="col-12 text-center pb-5">
          <h2 className="font-alt2 white title-extra-large-2">Don't Miss It!</h2>
          <span className="d-block font-alt2 text-gray-100 text-large">June 27, 2019</span>
          <span className="d-block font-alt2 mt-1 text-gray-300 text-large">Turtle Bay, Kahuku, HI</span>
        </div>
      </div>

      <div className="row">
        <div className="col-12 border-top py-5 text-center">
          <p className="font-alt font-w-600 letter-spacing-1 mb-0 text-extra-small text-gray-300 text-uppercase">
            <span className="text-base-color"> June 27, 2019 Wedding</span>
          </p>
        </div>

      </div>

    </div>
  </footer>
);
export default FooterSection;
